import React from "react";
import { quotes, angle } from "../../assets";

const LeftSection = () => {
  return (
    <section className="md:flex md:flex-1 md:max-w-[660px] md:min-h-[100vh] md:sticky md:top-0 loginbackground hidden">
      <div className="flex flex-col bg-secondary/40 backdrop-blur-sm max-w-[660px] ">
        {/* <img
          src={logo}
          className="lg:ml-16 ml-6 my-5 w-[124px] h-[48px]"
          alt="logo"
        /> */}
        <div className="flex flex-col justify-center items-center h-full gap-4">
          <div className="flex flex-col justify-center items-start lg:px-28 px-6 gap-4">
            <img src={quotes} alt="" className="self-start h-8 w-10" />
            <p className="text-white font-poppins lg:text-[18px] text-sm px-4 lg:leading-8">
              Those people who develop the ability to continuously acquire new
              and better forms of knowledge that they can apply to their work
              and to their lives will be the movers and shakers in our society
              for the indefinite future
            </p>
            <span className="self-start text-white font-poppins font-medium lg:text-[18px] text-sm px-4 lg:leading-8 p-4 ">
              - Brian Tracy
            </span>

            <img src={angle} alt="" className="h-8 w-8 self-end" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeftSection;
